module.exports = {"341182001":"明光街道","341182002":"明东街道","341182003":"明南街道","341182004":"明西街道","341182100":"张八岭镇","341182101":"三界镇","341182102":"管店镇","341182103":"自来桥镇","341182104":"涧溪镇","341182105":"石坝镇","341182106":"苏巷镇","341182107":"桥头镇","341182108":"女山湖镇","341182109":"古沛镇","341182110":"潘村镇","341182111":"柳巷镇","341182200":"泊岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341182.json
// module id = 1028
// module chunks = 0